<script setup lang="ts">
import type { CustomerAddress } from '@/types/customer';

interface Props {
  customerAddresses: CustomerAddress[];
  selectedAddressId?: number | undefined;
}

const props = defineProps<Props>();
const emit = defineEmits<{
  'address-selected': [address: CustomerAddress];
  'show-address-manager': [];
}>();

const selectAddress = (address: CustomerAddress) => {
  emit('address-selected', address);
};

const showAddressManager = () => {
  emit('show-address-manager');
};
</script>

<template>
  <div
    v-if="customerAddresses.length > 0"
    class="mt-3"
  >
    <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-2">
      Dirección de Entrega
    </label>
    <div class="space-y-2">
      <div
        v-for="address in customerAddresses"
        :key="address.id"
        class="p-2 border rounded-lg cursor-pointer transition-colors active:scale-[0.98]"
        :class="selectedAddressId === address.id 
          ? 'border-indigo-500 bg-indigo-50 dark:bg-indigo-900/20' 
          : 'border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800'"
        @click="selectAddress(address)"
      >
        <div class="flex justify-between items-start">
          <div class="flex-1 min-w-0">
            <p class="text-xs font-medium text-gray-900 dark:text-gray-100 truncate">
              {{ address.short_address }}
            </p>
            <p class="text-xs text-gray-500 dark:text-gray-400 mt-1 truncate">
              {{ address.full_address }}
            </p>
          </div>
          <div class="flex items-center space-x-2 flex-shrink-0 ml-2">
            <!-- Selected checkmark -->
            <div
              v-if="selectedAddressId === address.id"
              class="w-5 h-5 rounded-full bg-green-500 flex items-center justify-center"
            >
              <svg
                class="w-3 h-3 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="3"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span
              v-if="address.is_default"
              class="text-xs px-1 py-0.5 rounded-full bg-indigo-100 dark:bg-indigo-900/30 text-indigo-800 dark:text-indigo-200"
            >
              Predeterminada
            </span>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Address Management Actions -->
    <div class="mt-3">
      <div class="flex flex-col sm:flex-row sm:space-x-2 space-y-2 sm:space-y-0">
        <button
          class="w-full sm:w-auto text-xs px-3 py-2 bg-indigo-600 hover:bg-indigo-700 dark:bg-indigo-500 dark:hover:bg-indigo-600 text-white rounded-md transition-colors font-medium"
          @click="showAddressManager"
        >
          Gestionar Direcciones
        </button>
      </div>
    </div>
  </div>
</template>
